import moment from 'moment';
import getItemStyles from '../../../utils/item-styles';
/**
 * Returns a formatted day off item for the seven to nine day posted schedule.
 * @param {*} resource
 * @param {*} dayType
 */
const generateDayOffRequest = (resource, dayType, dayOffStartTime, tempDorId) => {
  const { rId } = resource;
  const { dayOffRequest } = dayType;
  const { dorId, abbreviation, dayOffRequestTitle, dayTypeComment, myDayTypeComment } = dayOffRequest;
  const offTimeStyle = getItemStyles('dayOffRequest');
  let hasComment = false;
  if (myDayTypeComment) {
    hasComment = true;
  }

  // Used if a day off request goes over multiple days
  const id = tempDorId ? tempDorId : dorId;

  return {
    id,
    itemType: 'off-request',
    group: rId,
    dorId,
    title: dayOffRequestTitle || `Days off request: ${abbreviation}`,  // postedSched || liveSched
    start_time: dayOffStartTime.startOf('day'),
    end_time: moment(dayOffStartTime).endOf('day'),  // A.A. - changed this from  'startOf' --> 'endOf' to fix a bug, don't recall what it was
    dayTypeComment,
    myDayTypeComment,
    backgroundColor: offTimeStyle.backgroundColor,
    color: offTimeStyle.color,
    borderStyle: offTimeStyle.borderStyle,
    borderColor: hasComment ? "red" : offTimeStyle.borderColor
  };
}

export default generateDayOffRequest;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/generate-timeline/generateDayOffRequest.js